import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export const GuaranteeSection = () => {
  return <section className="py-24 bg-cream" data-id="element-122">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl p-8 sm:p-12 border border-neutral-200 text-center shadow-md relative overflow-hidden" data-id="element-124">
          <ShieldCheck className="w-20 h-20 text-brand-600 mx-auto mb-8" data-id="element-125" />

          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-8" data-id="element-126">
            GARANTÍA TOTAL DE 7 DÍAS
          </h2>

          <div className="space-y-6 text-lg text-neutral-700" data-id="element-127">
            <p data-id="element-128">
              Si en 7 días sentís que CAJA DE COBRO no valió lo que pagaste, te
              devolvemos el 100% del dinero.
            </p>
            <p className="font-bold text-neutral-900" data-id="element-129">
              Sin formularios. Sin excusas. Sin drama.
            </p>

            <div className="bg-cream p-6 rounded-xl border border-neutral-200 mt-8" data-id="element-130">
              <p className="mb-2 text-neutral-700" data-id="element-131">
                El riesgo real no es invertir $19.990 en este sistema.
              </p>
              <p className="text-brand-700 font-bold text-xl m-0" data-id="element-132">
                El riesgo real es seguir otros 30 días más sin él.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};